import { render, staticRenderFns } from "./ParticipantDetailsCard.vue?vue&type=template&id=c9478052&scoped=true&"
import script from "./ParticipantDetailsCard.vue?vue&type=script&lang=js&"
export * from "./ParticipantDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantDetailsCard.vue?vue&type=style&index=0&id=c9478052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9478052",
  null
  
)

export default component.exports